module.exports = __webpack_public_path__ + "img/google_logo_colored.8809383d.png";